<script>
import BlockContent from '../UI/Content/BlockContent.vue'
import DataTable from '../UI/Table/DataTable.vue'
import mixinComponent from '../../Mixins/mixinComponent'
import { globalVariablesMixin } from '../../Mixins/global'
import { isAdmin } from '../../Utils'

export default {
  components: { DataTable, BlockContent },
  mixins: [mixinComponent, globalVariablesMixin],

  props: {
    entityId: { type: Number, required: true },
  },

  computed: {
    columns() {
      return [
        {
          name: 'id',
          title: this.$t('simulation.list.table.labelNumber'),
          style: { className: 'col-align-center', width: '20px;' },
          formatter: 'context',
          options: { renderType: 'simulation' },
        },
        { name: 'createdAt', title: this.$t('simulation.list.table.labelCreatedAt'), type: 'date', formatter: 'date' },
        { name: 'clientId', displayable: false },
        { name: 'supplierId', displayable: false },
        {
          name: 'supplier.name',
          displayable: isAdmin(),
          title: this.$t('main.supplier'),
          style: { width: '200px;' },
          formatter: 'entity',
          options: { renderId: 'supplierId' },
        },
        {
          name: 'client.name',
          title: this.$t('main.client'),
          style: { width: '150px;' },
          formatter: 'entity',
          options: { renderId: 'clientId' },
        },
        { name: 'platformSalesman.name', title: this.$t('simulation.list.table.labelPlatformSalesman') },
        { name: 'finance.contractType.name', title: this.$t('simulation.list.table.labelContractType') },
        { name: 'decisionAmount', title: this.$t('simulation.list.table.labelAmount'), formatter: 'currency' },
        { name: 'decisionRent', title: this.$t('simulation.list.table.labelRent'), formatter: 'currency' },
        {
          name: 'finance.duration',
          title: this.$t('simulation.list.table.labelDuration'),
          style: { className: 'col-align-center', width: '20px;' },
        },
        { name: 'finance.nbRentFree', title: this.$t('simulation.list.table.labelRentFree') },
        { name: 'refinancerStatus', displayable: false },
        {
          name: 'status',
          title: this.$t('simulation.list.table.labelStatus'),
          formatter: 'status',
          options: { renderType: 'simulation' },
        },
      ]
    },
    urlSimulation() {
      return 'entities/' + this.entityId + '/simulations'
    },
  },

  methods: {
    getSimulations(callback) {
      return this.getJSON(this.urlSimulation).then((simulations) => {
        callback({ data: simulations })
      })
    },
  },
}
</script>
<template>
  <BlockContent>
    <DataTable
      id="listeSimulationSociete"
      :columns="columns"
      :fetch="getSimulations"
      ref="listeSimulationSociete"
      :order="[[0, 'desc']]"
      zero-records="$t('simulation.list.zeroRecords')"
    />
  </BlockContent>
</template>
